import { render, staticRenderFns } from "./PurchaseNavigation.vue?vue&type=template&id=d2e2f7e4"
import script from "./PurchaseNavigation.vue?vue&type=script&lang=ts"
export * from "./PurchaseNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports